import { HttpErrorResponse } from '@angular/common/http';

import { createActions, ngrxEvent } from '@recruitee/ngrx';

import { SchedulerAvailability } from './types';

const namespace = 'viewboxInterviewSchedule';

export const ViewboxInterviewScheduleActions = createActions(namespace, {
  loadItem: ngrxEvent<{
    scheduleToken: string;
    requestLinkToken: string;
    candidateTimezone: string;
  }>(),
  loadItemSuccess: ngrxEvent<SchedulerAvailability>(),
  loadItemFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
  confirmSchedule: ngrxEvent<{
    scheduleToken: string;
    requestLinkToken: string;
    startsAt: string;
    candidateTimezone: string;
  }>(),
  confirmScheduleSuccess: ngrxEvent<SchedulerAvailability>(),
  confirmScheduleFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
});
